import React, { ChangeEvent, forwardRef } from 'react';
import './TextArea.scss';

interface TextAreaProps extends React.HTMLAttributes<HTMLTextAreaElement> {
  label: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, name, placeholder, required, value, onChange, className = '', ...props }, ref) => {
    return (
      <label className={'c-textarea ' + className}>
        <span className='c-textarea-label'>{`${label || ''} ${required ? '*' : ''}`}</span>
        <textarea
          ref={ref}
          name={name}
          id={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className='c-textarea-field'
          {...props}
        />
      </label>
    );
  }
);
